import styled, { css } from 'styled-components';

export const WrapperSubtitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 10px;
  padding: 0;
`;

export const Subtitle = styled.p`
  ${({ theme }) => css`
    background: linear-gradient(90deg, #23CAB3 0%, var(--Colors-Brand-Medium, #0070D1) 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: ${theme.v2.colors.brand.primaryBlue};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }
  `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryBlue};
    font-family: ${theme.v2.font.family.primary};
    font-size: 32px;
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 1.4;
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.sm2};
      max-width: 300px;
    }
  `}
`;

export const Description = styled.p`
 ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 1.5;
    margin: 0 0 24px;
    
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xs};
      margin: 0 0 20px;
    }
  `}
`;

export const DescriptionList = styled.ul`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
  `}
`;

export const DescriptionListItem = styled.li`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    padding: 0;
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 140%;
    list-style: none;
    text-align: left;

    svg {
      width: 20px;
      height: 20px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xs};
      justify-content: center;
    }
  `}
`;

export const BadgeWrapper = styled.div`
  margin: 16px 0;
`;
